import React from "react";
import { HiArrowLeft } from "react-icons/hi";
import Loader from "../../../pages/commons/Loading";
import {
  useSearchCustomerVehicleDetailMutation,
  useUpdateCustomerVehicleDetailMutation,
} from "../../../redux/services/VehicleApi";
import { useState, useEffect } from "react";
import { Button } from "@mui/material";
import { selectData, selectJwtToken } from "../../../redux/slices/authSlice";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../redux/app/hooks";
import {
  getVehicleData,
  setVehicle,
  getVehicleTotalPages,
} from "../../../redux/slices/vehicleSlice";
import { AiOutlinePlus } from "react-icons/ai";
import { BsFillEmojiFrownFill, BsHeart, BsHeartFill } from "react-icons/bs";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";

type Props = {};
const MyCars = (props: Props) => {
  const [getVehicle, getVehicleResponse] =
    useSearchCustomerVehicleDetailMutation();
  const [vehicleDataTemp, setvehicleDataTemp] = useState<any>();
  const navigate = useNavigate();
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const token: string = currentUser?.jwtToken;
  const userDataRoot: any = useAppSelector(selectData);
  const vehicleData = useAppSelector(getVehicleData);
  const dispatch = useAppDispatch();
  const [offset, setOffset] = useState(5);
  const [page, setPage] = useState(0);
  const totalPageRecord = useAppSelector(getVehicleTotalPages);

  const getVehicleByPagination = async (reqOffset: number, reqPage: number) => {
    await getVehicle({
      token: token,
      payload: {
        customerId: userDataRoot?.customerId,
        offset: reqOffset,
        page: reqPage,
        status: true,
      },
    });
  };

  useEffect(() => {
    if (token) {
      getVehicle({
        token: token,
        payload: {
          customerId: userDataRoot?.customerId,
          offset: offset,
          page: page,
          status: true,
        },
      });
    }
  }, [token]);

  const handleLoadMore = () => {
    setPage(page + 1);
    getVehicleByPagination(offset, page + 1);
  };

  const handleLoadMores = () => {
    setPage(page - 1);
    getVehicleByPagination(offset, page - 1);
  };

  useEffect(() => {
    if (getVehicleResponse.isSuccess) {
      dispatch(setVehicle(getVehicleResponse.data));
    }
  }, [getVehicleResponse.isSuccess]);

  useEffect(() => {
    if (vehicleData) {
      setvehicleDataTemp(vehicleData);
    }
  }, [vehicleData]);

  return (
    <div>
      {getVehicleResponse.isLoading && <Loader />}
      <div className=" rounded-[8px] border-2  lg:m-[50px] m-[20px] lg:mx-8 mx-2 p-[20px] lg:p-[32px] ">
        <div className="text-[#434343] font-medium mb-[2%] lg:text-[32px] text-[26px]  flex flex-row justify-between">
          <p>My Vehicle </p>
          <button
            className="px-25 text-lg  w-[40%] md:w-[20%] sm:w-[20%] border-2 py-[0.5%] rounded border-red-600 text-red-600"
            onClick={() => {
              navigate("/profile/vehicle/myvehicle", {
                state: { editMode: true, isNavigate: false },
              });
            }}
          >
            <span>Add a vehicle</span>
            <AiOutlinePlus className="inline-flex"></AiOutlinePlus>
          </button>
        </div>

        {vehicleDataTemp &&
          vehicleDataTemp.map((response: any, index: number) => (
            <div className="flex flex-col w-full mx-auto p-4 border-2 border-gray-300 rounded-lg mb-8">
              <div className="flex-row flex justify-between">
                <div className="flex-col ">
                  <p className="text-black text-lg font-bold">
                    {response.vehicleNumber}
                  </p>
                  <p className="text-gray text-base font-medium">
                    {response.makerName}
                  </p>{" "}
                </div>
                <div className="flex-col">
                  <button
                    className="border-2 border-red-500  text-red-500 h-[100%]  p-2 w-14 mb-1 rounded text-base"
                    onClick={() => {
                      navigate("/profile/vehicle/myvehicle", {
                        state: { editMode: false, response: response },
                      });
                    }}
                  >
                    Edit
                  </button>
                </div>
              </div>
              <div className="flex flex-row w-full justify-between ">
                <div className=" w-[50%] sm:w-[30%]">
                  <div className="bg-green-500 mt-2 px-2 py-1 rounded-full flex-end">
                    <div className="text-center text-white text-base font-medium">
                      {response.isCommercial == "YES"
                        ? "Commercial"
                        : "Private"}
                    </div>
                  </div>
                </div>
                {response.isPrimary ? (
                  <div className=" w-[40%] sm:w-[30%]">
                    <div className="bg-green-500 mt-2 px-2 py-1 rounded-full ">
                      <div className="text-center text-white text-base font-medium">
                        Primary Vehicle
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          ))}
        {vehicleDataTemp && vehicleDataTemp.length === 0 ? (
          <div className="justify-between items-center flex flex-col mt-6 mb-10">
            <BsFillEmojiFrownFill size={70} color={"ef4444"} />
            <h5 className="text-xl pt-4">No Vehicle in your list!!!</h5>
          </div>
        ) : (
          <div className="flex gap-6 justify-center">
            <button
              onClick={() => {
                handleLoadMores();
              }}
              disabled={page == 0 ? true : false}
              className={` p-2 rounded-[8px] flex items-center ${
                page == 0
                  ? "bg-slate-300 text-black"
                  : "text-white bg-[#E23744] hover:bg-red-700 "
              }`}
            >
              <BiChevronLeft />
              Previous{" "}
            </button>
            <button
              onClick={() => {
                handleLoadMore();
              }}
              disabled={page + 1 === totalPageRecord ? true : false}
              className={` p-2 flex items-center rounded-[8px] ${
                page + 1 == totalPageRecord
                  ? "bg-slate-300 text-black"
                  : "text-white bg-[#E23744] hover:bg-red-700 "
              }`}
            >
              Next
              <BiChevronRight />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyCars;
